import { _axios } from "../../Utils/Axios/axios";

export const getGrades_Service = async () => {
  return _axios.get("/grade");
};
